'use strict';

import 'select2';
import './modules/select2-position';
import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';

Fancybox.defaults.Hash = false;

window.TWER_LIBS = {
  fancybox : Fancybox
}
